import Request from '@/utils/request'

// 查询邀请统计：累计邀请人数、累计邀请奖励、首次通话奖励、首次充值奖励
export function apiFetchInviteStatistics(params) {
  return Request({
    url: '/api/v2/app/male/invite/statistics',
    method: 'get',
    params,
    envelope: true,
  })
}

// 查询用户邀请码
export function apiFetchInviteCode(params) {
  return Request({
    url: '/api/v2/app/male/invite/code',
    method: 'get',
    params,
    envelope: true,
  })
}
